export default __webpack_public_path__ + "static/media/dino.a0bdc473.png";